import { Wallet } from "./wallet";
import { Address } from "@/lib/web3x-es/address";
import { toBN } from "@/lib/web3x-es/utils";

import { Eth } from "@/lib/web3x-es/eth";
import WalletConnectProvider from "@walletconnect/web3-provider";

import EventBus, { ACTIONS } from "@/event-bus";

class WalletConnect implements Wallet {
  private currentAddress = "";
  private currentChainId = "";
  private provider: any = null;

  public isConnected(): boolean {
    return this.provider && this.provider.connected;
  }

  public async disconnect() {
    this.currentAddress = "";
    this.currentChainId = "";
    await this.provider.close();
    this.provider = null;
  }

  public getAddress() {
    return this.currentAddress;
  }

  public getChain() {
    const chainIds: any = {
      137: "matic",
      80001: "mumbai",
    };
    return chainIds[this.currentChainId];
  }

  public getChainId() {
    return this.currentChainId;
  }

  public async connect() {
    try {
      // these are http providers
      this.provider = new WalletConnectProvider({
        rpc: {
          80001: process.env.VUE_APP_CHILDCHAIN_PROVIDER_HTTP || "",
          137: process.env.VUE_APP_CHILDCHAIN_PROVIDER_HTTP || "",
        },
      });

      await this.provider.enable();

      console.debug("connect OK... ->", this.provider.accounts[0]);

      this.currentAddress = this.provider.accounts[0];
      this.currentChainId = this.provider.chainId;

      this.provider.on("chainChanged", (chainId: number) => {
        console.debug("chainChanged :: ", chainId);

        this.currentChainId = this.provider.chainId;
        EventBus.$emit(ACTIONS.ETH_UPDATE_ACCOUNTS);
      });

      this.provider.on("accountsChanged", (acc: string[]) => {
        console.debug("accountsChanged :: ", acc[0]);

        this.currentAddress = acc[0];
        EventBus.$emit(ACTIONS.ETH_UPDATE_ACCOUNTS);
      });

      this.provider.on("disconnect", () => {
        EventBus.$emit(ACTIONS.ETH_UPDATE_ACCOUNTS);
      });

      EventBus.$emit(ACTIONS.ETH_UPDATE_ACCOUNTS);
    } catch (err) {
      console.log(err);
    }
  }

  public async sendTransaction(txParams: any) {
    if (txParams.from === undefined) {
      txParams.from = this.getAddress();
    }

    if (txParams.value) {
      txParams.value = toBN(txParams.value).toString(16);
    }

    console.debug("txParams ::", txParams);

    return this.provider.request({
      method: "eth_sendTransaction",
      params: [txParams],
    });
  }

  public async getBlockNo(): Promise<number> {
    return this.getEthProvider().getBlockNumber();
  }

  public getBalance() {
    return this.getEthProvider().getBalance(
      Address.fromString(this.currentAddress)
    );
  }

  public getEthProvider(): any {
    return new Eth(this.provider);
  }

  public getIcon(): any {
    return "/img/logos/walletconnect.svg";
  }
}

export default WalletConnect;
